import { GetCalendarLinksQueryResult } from '@modernhealth/circles-graphql/v2';
import React, { useMemo } from 'react';

import { AddToCalendarModal, AddToCalendarModalProps, Calendar } from './AddToCalendarModal';

export function useCalendarLinksForCircle(data: GetCalendarLinksQueryResult['data']) {
    const calendarLinks = useMemo(() => {
        if (data?.circleCalendarLinksByRsvp?.__typename !== 'CircleCalendarLinks') return null;

        const googleLink = data.circleCalendarLinksByRsvp.google;
        const outlookLink = data.circleCalendarLinksByRsvp.outlook;
        const ics = data.circleCalendarLinksByRsvp.ics;

        return {
            [Calendar.GOOGLE_CALENDAR]: googleLink ?? null,
            [Calendar.ICS]: ics ? `https://api.joinmodernhealth.com${ics}` : null,
            [Calendar.OUTLOOK]: outlookLink ?? null,
        };
    }, [data]);

    return calendarLinks;
}

export const CirclesAddToCalendarModal: React.FC<Omit<AddToCalendarModalProps, 'calendars'>> = ({
    visible,
    onClose,
    calendarLinks,
}) => {
    return (
        <AddToCalendarModal
            visible={visible}
            onClose={onClose}
            calendarLinks={calendarLinks}
            calendars={[Calendar.GOOGLE_CALENDAR, Calendar.OUTLOOK, Calendar.ICS]}
        />
    );
};
